var Font = function (size, weight, family) {
  this.size = this._size = size;
  this.weight = weight;
  this.family =
    family
      .split(/\,\s*/)
      .map(function (item) {
        return `"${item}"`;
      })
      .join(', ') + ', sans-serif';
  // this.family = family;
  return this;
};

Font.prototype.scale = function (scale) {
  this.size = this._size * scale;
  return this;
};

Font.prototype.getSize = function () {
  return this.size;
};

Font.prototype.toString = function () {
  return '{fw} {fs}px {ff}'
    .replace('{fs}', this.size)
    .replace('{fw}', this.weight)
    .replace('{ff}', this.family);
};

export default Font;
